document.addEventListener("DOMContentLoaded", function() {
  const scrollContainer = document.getElementById("topbar-link");
  const scrollText = document.getElementById("scroll-text");

  if (scrollContainer === undefined || scrollContainer === null) return;
  if (scrollText === undefined || scrollText === null) return;

  function checkTextWidth() {
    const containerWidth = scrollContainer.offsetWidth;
    const textWidth = scrollText.scrollWidth;
    const scrollCopy = document.getElementById("scroll-text-copy");
    if (scrollCopy != null) scrollCopy.remove()

    if (textWidth > containerWidth) {
      const clonedText = scrollText.cloneNode(true);
      clonedText.id = "scroll-text-copy";
      scrollContainer.insertBefore(clonedText, scrollText.nextSibling)
      scrollText.style.animation = `scroll ${textWidth / 50}s linear infinite`;
      clonedText.style.animation = `scroll ${textWidth / 50}s linear infinite`;
    } else {
      scrollText.style.animation = "none";
    }
  }

  checkTextWidth();
  window.addEventListener("resize", checkTextWidth);
});
